import { render, staticRenderFns } from "./add-role-modal.vue?vue&type=template&id=065c9e64&"
import script from "./add-role-modal.vue?vue&type=script&lang=js&"
export * from "./add-role-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports